'use client';

import type { InterfaceEntity } from '@unifyapps/defs/types/interface';
import type { UseFetchInterfaceAppResourcesHookType } from '../../../../types';
import { useGetAuthDeployedInterfaceById } from '../../useAuthDeployedInterface';
import { useAuthAppResourcesFromRecord } from '../useFetchAuthDeployedInterfaceAppResources/useAuthAppResourcesFromRecord';

/**
 * PlatformAuthorization strategy (app resources) — resolves the `ua-platform` record by explicit id
 * via the public, session-free `/auth/interface/deployed/{id}` route, then runs the shared auth app
 * tail. Counterpart of `useFetchPlatformAuthDeployedInterfaceResources` at the app level.
 */
const useFetchPlatformAuthDeployedInterfaceAppResources: UseFetchInterfaceAppResourcesHookType = ({
  interfaceId,
  client,
  mode,
}) => {
  const platformAuthInterface = useGetAuthDeployedInterfaceById<InterfaceEntity>(interfaceId, {
    query: {
      enabled: Boolean(interfaceId),
      staleTime: Infinity,
    },
  });

  return useAuthAppResourcesFromRecord({
    interfaceId,
    client,
    mode,
    interfaceRecord: platformAuthInterface.data,
    isLoadingInterfaceRecord: platformAuthInterface.isLoading,
    errorInterfaceRecord: platformAuthInterface.error,
    // session-free by-id route has no auth override endpoint — skip the override on this path
    overrideSource: 'none',
  });
};

export default useFetchPlatformAuthDeployedInterfaceAppResources;
